import { z } from 'zod';

export const customerSchema = z
  .object({
    name: z.string().min(1, 'Name is required'),
    mobile: z.string().min(8, 'Mobile must be at least 8 digits'),
    email: z.string().email('Enter a valid email').or(z.literal('')).optional(),
    postal: z.string().length(6, 'Postal code must be 6 digits').or(z.literal('')).optional(),
    unit: z.string().optional(),
    blk: z.string().optional(),
    street: z.string().optional(),
    building: z.string().optional(),
    preparedBy: z.string().optional(),
    hasDifferentInstall: z.boolean().optional(),
    installPostal: z.string().optional(),
    installUnit: z.string().optional(),
    installBlk: z.string().optional(),
    installStreet: z.string().optional(),
    installBuilding: z.string().optional(),
    installName: z.string().optional(),
    installMobile: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.hasDifferentInstall) {
      if (!data.installName || data.installName.trim() === '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Site contact name is required',
          path: ['installName'],
        });
      }
      if (!data.installMobile || data.installMobile.length < 8) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Site mobile must be at least 8 digits',
          path: ['installMobile'],
        });
      }
      if (!data.installPostal || data.installPostal.length !== 6) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Install postal code must be 6 digits',
          path: ['installPostal'],
        });
      }
    }
  });
